import * as actionTypes from 'redux/actions'

const initialState = {
  campaigns: undefined
}

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_DATA: {
      return {
        ...state,
        ...action.payload
      }
    }
    default: {
      return state
    }
  }
}

export default dashboardReducer
